import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CtaButtonProps {
  label?: string;
  variant?: 'primary' | 'light';
  className?: string;
}
export function CtaButton({
  label = 'Quiero el método ahora',
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const styles = variant === 'light' ? 'bg-white text-brand-700 hover:bg-brand-50' : 'bg-brand-600 text-white hover:bg-brand-700 shadow-lg shadow-brand-500/30';
  return <button onClick={scrollToOffer} className={`inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-bold text-lg transition-all hover:-translate-y-1 hover:shadow-xl ${styles} ${className}`} data-id="element-37">
      {label}
      <ArrowRight className="w-5 h-5" data-id="element-38" />
    </button>;
}